import { Form, Input, Select, Space } from 'antd';
import { map } from 'lodash';
import React from 'react';
import countryCode from '../assets/countryCode.json';
import { EXCEPT_THIS_SYMBOLS } from '../common/constants';

const PhoneNumberInputWithCountyCode = ({
  formItemName = 'countryCode',
  ...rest
}) => {
  return (
    <Space.Compact block>
      <Form.Item name={formItemName} className="country-code-input">
        <Select
          showSearch={{ optionFilterProp: 'label' }}
          placeholder="Code"
          getPopupContainer={(trigger) => trigger?.parentElement}
          options={[
            ...map(countryCode, (record) => ({
              label: record?.dialCode,
              value: record?.id,
            })),
          ]}
        />
      </Form.Item>
      <Input
        onKeyDown={(e) =>
          EXCEPT_THIS_SYMBOLS.includes(e?.key) && e?.preventDefault()
        }
        className="country-code-phone-input"
        placeholder="Enter Mobile Number"
        {...rest}
      />
    </Space.Compact>
  );
};

export default PhoneNumberInputWithCountyCode;
